import React from 'react';
import PropTypes from 'prop-types';
import { companyOptionStyle, messageStyle, nameStyle } from './styles';

const CompanyNameOption = ({
  addCompanyMessage,
  alreadySelected,
  disabled,
  name,
  nameExistsMessage,
}) => (
  <div css={companyOptionStyle}>
    <div css={nameStyle(disabled)}>{name}</div>
    {disabled && <div css={messageStyle(disabled)}>{nameExistsMessage}</div>}
    {!disabled && !alreadySelected && (
      <div css={messageStyle(disabled)}>{addCompanyMessage}</div>
    )}
  </div>
);

CompanyNameOption.propTypes = {
  addCompanyMessage: PropTypes.string,
  alreadySelected: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  nameExistsMessage: PropTypes.string.isRequired,
};

CompanyNameOption.defaultProps = {
  addCompanyMessage: '',
  alreadySelected: false,
};

export default CompanyNameOption;
